/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';

import {AdServerConfig, ApiConfig} from '../config/api-config';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

export interface CreativePreviewResponse {
  html: any;
}

@Injectable({providedIn: 'root'})
export class CreativePreviewApiService {
  private readonly uri = this.apiConfig.getVersionedUri('creativepreview');

  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  get(creativeId: string): Observable<CreativePreviewResponse> {
    return this.client.request<CreativePreviewResponse>({
      method: 'GET',
      url: this.uri + '/' + encodeURIComponent(creativeId)
    });
  }

  render(previewData: any): Observable<any> {
    return this.client.request<any>({
      method: 'POST',
      url: AdServerConfig.obtain().getUri('preview'),
      body: previewData,
      responseType: 'text'
    }).pipe(map((data) => {
      if (typeof data !== 'string') {
        return data;
      }
      if (data.indexOf('html') > -1) {
        return {document: data};
      }
      try {
        return JSON.parse(data);
      } catch (_error) {
        return data;
      }
    }));
  }
}
